import TemplateOneFull from "./full-preview/template-one";
import React, {useMemo} from "react";
import TemplateTwoFullPageOne from "./full-preview/template-two/page-one";
import { TEMPLATE_NAME_1,TEMPLATE_NAME_2,TEMPLATE_NAME_4, TEMPLATE_NAME_5 } from "constants/options";
import TemplateFourFullPageOne from "./full-preview/template-four/page-one";
import TemplateFiveFullPageOne from "./full-preview/template-five/page-one";
import _ from "lodash";
const TemplateCover = ({more_info,personal_info,template_color, profile,template_name})=>{
    const [primaryColor, secondaryColor, tertiaryColor, quarternary] =
        useMemo(() => {
          if (!_.isEmpty(template_color.color)) {
            return template_color.value;
          }
          return ["", "", "", ""];
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [template_color.color]);

    return(
        <>
        {
            template_name === TEMPLATE_NAME_1 &&
            <TemplateOneFull
            {...{
                page:1,
                primaryColor,
                secondaryColor,
                tertiaryColor,
                profile,
            }}
            details={more_info}
            personal={personal_info}
            // social={state.social}
            setTotalPage={1}                      
            />
        }
        {
            template_name === TEMPLATE_NAME_2 &&
            <TemplateTwoFullPageOne
                {...{
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    quarternary,
                    profile,
                }}
                color={template_color}
                active={true}
                details={more_info}
                personal={personal_info}
                social={[]}
                />
        }
        {
            template_name === TEMPLATE_NAME_4 &&
            <TemplateFourFullPageOne
                {...{
                primaryColor,
                secondaryColor,
                tertiaryColor,
                quarternary,
                profile,
                }}
                color={template_color}
                active={true}
                details={more_info}
                personal={personal_info}
                social={[]}
            />
        }
        {
            template_name === TEMPLATE_NAME_5 &&
            <TemplateFiveFullPageOne
                {...{
                primaryColor,
                secondaryColor,
                tertiaryColor,
                quarternary,
                profile,
                }}
                color={template_color}
                active={true}
                details={more_info}
                personal={personal_info}
                social={[]}
            />
        }
        
        </>
    )
}

export default TemplateCover;